import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MappingDependency } from '@classes/mapping/mapping-dependency';

@Component({
    selector: 'app-items-list',
    templateUrl: './items-list.component.html',
    styleUrls: ['./items-list.component.scss']
})
export class ItemsListComponent implements OnChanges {
    @Input() items: MappingDependency[] = [];
    @Input() selection: any[];
    @Output() itemSelected = new EventEmitter<any>();

    filteredItems: MappingDependency[] = [];

    constructor() { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.items?.currentValue !== changes.items?.previousValue)
            this.initItems();
    }

    onItemSelected(item: any): void {
        this.itemSelected.emit(item);
    }

    isItemSelected(item: any): boolean {
        return !!this.selection.find(s => s.id === item.id);
    }

    private initItems(): void {
        this.items = this.items ? this.items.sort((a, b) => a.code.toLowerCase() < b.code.toLowerCase() ? -1 : 1) : [];
        this.filteredItems = [...this.items];
    }

}
